import { ControlOutlined } from '@ant-design/icons'
import FormCard from '@components/FormCard'
import Page from '@components/Page/Page'
import { SettingKey } from '@models/Setting'
import { useAppDispatch } from '@store/hooks'
import { getSettings } from '@store/SettingReducer'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { Permission } from '@utils/permissions'
import { useEffect } from 'react'

const IntegrationsUberPage = () => {
  const dispatch = useAppDispatch()

  const fetchSettings = () => {
    dispatch(getSettings([SettingKey.INTEGRATIONS_UBER_ENABLED]))
  }

  useEffect(() => {
    fetchSettings()
  }, [])

  return (
    <Page
      permissions={Permission.manageIntegrationUber}
      pageTitle={{
        title: 'Uber',
        level: 4,
      }}
    >
      <FormCard
        title="Activate integration"
        description="Enable or disable the Uber VTC button on the application venue page."
        icon={<ControlOutlined />}
        entity={Entity.setting}
        action={SBRMAction.Update}
        metadata={[
          {
            key: MetadataKey.Setting,
            value: SettingKey.INTEGRATIONS_UBER_ENABLED,
          },
        ]}
      />
    </Page>
  )
}

export default IntegrationsUberPage
